import { Box, Container, styled, Typography } from '@mui/material';

const StyleReviewsSection = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  paddingLeft: '0px !important',
  paddingRight: '0px !important',
  minHeight: '60px',
  width: '100%',
  background: theme.palette.other.gray,
  color: theme.palette.black.main,

  h3: {
    color: theme.palette.blue[10],
    marginBottom: '10px',
    fontSize: '28px',
    lineHeight: '32px',
    fontWeight: theme.typography.fontWeightRegular,
  },

  p: {
    fontSize: '14px',
    lineHeight: '18px',
    fontWeight: theme.typography.fontWeightRegular,
  },

  footer: {
    background: theme.palette.blue.main,
    color: theme.palette.white.main,
  },

  [theme.breakpoints.down('sm')]: {
    section: {
      padding: '0px',
    },
  },
}));

const StyleContainer = styled(Container)(({ theme }) => ({
  paddingLeft: '0px !important',
  paddingRight: '0px !important',
  paddingTop: '36px',
  paddingBottom: '36px',
  width: '100%',
}));

const StyleInfoSection = styled(Box)(({ theme }) => ({
  maxWidth: '100%',
  marginLeft: '0',
  marginRight: '0',
  display: 'grid',
  gridTemplateColumns: '1fr',
  gap: '2rem',
  padding: '0',

  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: 'repeat(5, 1fr)',
    padding: '0px 8px',
  },

  [theme.breakpoints.up('md')]: {
    gridTemplateColumns: 'repeat(7, 1fr)',
  },

  [theme.breakpoints.down('sm')]: {
    padding: '0px 8px',
  },
}));

const StyleInfoSectionTripadvisorItem = styled(Box)(({ theme }) => ({
  gridColumn: 'span 1 / span 1',

  [theme.breakpoints.up('sm')]: {
    gridColumn: 'span 2 / span 2',
  },
}));

const StyleGoogleReviewsItem = styled(Box)(({ theme }) => ({
  gridColumn: 'span 1 / span 1',

  [theme.breakpoints.up('sm')]: {
    gridColumn: 'span 3 / span 3',
  },

  [theme.breakpoints.up('md')]: {
    gridColumn: 'span 5 / span 5',
  },
}));

const StyleTripadvisor = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  border: `1px solid ${theme.palette.green.border}`,
  borderRadius: '10px',
  padding: '16px',
  background: theme.palette.white.main,
  alignItems: 'center',

  '.title-tripadvisor': {
    ...theme.typography.body1,
    fontWeight: 600,
  },
}));

const StyleGoogleReviews = styled(Box)(({ theme }) => ({
  border: `1px solid ${theme.palette.blue.highlight}`,
  borderRadius: '10px',
  padding: '16px',
  background: theme.palette.white.main,
  minHeight: '28rem',
  overflow: 'hidden',

  '& body4': {
    ...theme.typography.body4,
    fontWeight: theme.typography.fontWeightRegular,
  },
}));

// TODO: Footer

const FooterRoot = styled('footer')(({ theme }) => ({
  position: 'absolute',
  bottom: 0,
  left: 0,
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  gap: '16px',
  background: theme.palette.blue.main,
  color: theme.palette.white.main,
  padding: '8px 0 0 0',

  [theme.breakpoints.down('lg')]: {
    padding: '8px',
  },
}));

const FooterContent = styled(Box)(({ theme }) => ({
  display: 'grid',
  gap: '32px',

  gridTemplateColumns: '1fr',

  [theme.breakpoints.up('sm')]: {
    gridTemplateColumns: 'repeat(4, 1fr)',
  },

  [theme.breakpoints.up('md')]: {
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    gridTemplateColumns: 'repeat(8, 1fr)',
  },
}));

const FooterLogoSection = styled(Box)(({ theme }) => ({
  marginBottom: '24px',

  gridColumn: 'span 1',

  [theme.breakpoints.up('sm')]: {
    gridColumn: 'span 2',
  },

  [theme.breakpoints.up('md')]: {
    marginBottom: 0,
    gridColumn: 'span 4',
  },
}));

const FooterAddress = styled('address')(({ theme }) => ({
  fontStyle: 'normal',
  margin: '8px 0 0 0',
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',

  p: {
    fontSize: '14px',
    lineHeight: '20px',
    margin: 0,
  },
}));

const FooterSocials = styled(Box)(({ theme }) => ({
  display: 'flex',
  gap: '24px',
  marginTop: '24px',
  marginBottom: '16px',
}));

const FooterDownloadSection = styled(Box)(({ theme }) => ({
  color: theme.palette.white.main,
  gridColumn: 'span 1',

  [theme.breakpoints.up('sm')]: {
    gridColumn: 'span 2',
  },
  [theme.breakpoints.up('md')]: {
    gridColumn: 'span 4',
  },

  h2: {
    ...theme.typography.h2,
    fontWeight: 700,
  },
}));

const FooterDownloadLink = styled('a')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  color: theme.palette.white.main,
  textDecoration: 'underline',
  fontWeight: theme.typography.fontWeightMedium,
  fontSize: '18px',
  marginBottom: '12px',
  '&:focus': {
    outline: 'none',
    boxShadow: `0 0 0 2px ${theme.palette.blue.main}`,
    borderRadius: '4px',
  },
}));

const FooterCopyright = styled(Box)(({ theme }) => ({
  marginTop: '32px',
  paddingTop: '24px',
  borderTop: `1px solid ${theme.palette.white.main}33`,
  display: 'flex',
  flexDirection: 'column',
  gap: '8px',
  alignItems: 'center',

  [theme.breakpoints.up('md')]: {
    flexDirection: 'row',
    justifyContent: 'space-between',
  },

  p: {
    fontSize: '14px',
    margin: 0,
  },

  a: {
    fontSize: '14px',
    color: theme.palette.white.main,
    textDecoration: 'underline',
    fontWeight: 500,

    '&:hover': {
      color: theme.palette.blue.highlight,
      transform: 'scale(0.95)',
      transition: 'all 0.2s ease-in-out',
    },
  },
}));

export {
  StyleReviewsSection,
  StyleContainer,
  StyleInfoSection,
  StyleInfoSectionTripadvisorItem,
  StyleGoogleReviewsItem,
  StyleTripadvisor,
  StyleGoogleReviews,
  FooterRoot,
  FooterContent,
  FooterLogoSection,
  FooterAddress,
  FooterSocials,
  FooterDownloadSection,
  FooterDownloadLink,
  FooterCopyright,
};
